import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const BorrowerProtectionIllustration = (props: SVGProps) => {
  const {
    title = 'BorrowerProtectionIllustration',
    className,
    ...restProps
  } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      viewBox="0 0 141 96"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
      fill="none"
    >
      <title>{title}</title>
      <g clipPath="url(#borrower-protection-clip)">
        <path
          d="M66.0939 82.4359C58.9698 79.6394 52.4605 75.6494 47.7714 71.2255C42.0818 65.8493 39.0803 59.8463 39.0803 53.8553V25.4073L66.9618 13.2446L94.6986 25.3711V53.8674C94.6986 59.8463 91.6971 65.8613 86.0075 71.2375C81.3184 75.6735 74.8091 79.6514 67.673 82.448L66.8774 82.7614L66.0818 82.448L66.0939 82.4359Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.578604"
          strokeMiterlimit="10"
        />
        <path
          d="M66.8897 43.0529C70.5247 43.0529 73.4713 40.1062 73.4713 36.4713C73.4713 32.8363 70.5247 29.8896 66.8897 29.8896C63.2548 29.8896 60.3081 32.8363 60.3081 36.4713C60.3081 40.1062 63.2548 43.0529 66.8897 43.0529Z"
          fill="black"
          stroke="black"
          strokeWidth="0.578604"
          strokeMiterlimit="10"
        />
        <path
          d="M66.8899 66.101V40.9799"
          stroke="black"
          strokeWidth="1.48267"
          strokeMiterlimit="10"
        />
        <path
          d="M71.254 58.2546H66.7698"
          stroke="black"
          strokeWidth="1.48267"
          strokeMiterlimit="10"
        />
        <path
          d="M71.254 62.2197H66.7698"
          stroke="black"
          strokeWidth="1.48267"
          strokeMiterlimit="10"
        />
        <path
          d="M55.9437 10.4387L66.9854 5.617L100.81 20.3955V55.1358C100.81 62.4287 97.1451 69.7576 90.2139 76.3151C84.5002 81.7275 76.5565 86.5854 67.8654 89.9967L66.901 90.3704L65.9367 89.9967C57.2456 86.5854 49.3018 81.7275 43.5881 76.3151C36.6569 69.7576 32.9924 62.4407 32.9924 55.1358V20.4437L55.9558 10.4266"
          stroke="url(#borrower-protection-gradient)"
          strokeWidth="0.96434"
          strokeMiterlimit="10"
        />
        <path
          d="M114.818 39.7438C114.818 32.7764 120.459 27.135 127.426 27.135C134.394 27.135 140.035 32.7885 140.035 39.7438C140.035 46.699 134.382 52.3525 127.426 52.3525C120.471 52.3525 114.818 46.699 114.818 39.7438Z"
          stroke="currentColor"
          strokeWidth="0.96434"
          strokeMiterlimit="10"
        />
        <path
          d="M127.426 49.784C132.971 49.784 137.48 45.2878 137.48 39.7428C137.48 34.1979 132.983 29.7017 127.426 29.7017C121.869 29.7017 117.385 34.1979 117.385 39.7428C117.385 45.2878 121.881 49.784 127.426 49.784Z"
          stroke="white"
          strokeWidth="0.96434"
          strokeMiterlimit="10"
        />
        <path
          d="M131.972 39.7336L127.421 35.182L122.869 39.7336L127.421 44.2852L131.972 39.7336Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.650929"
          strokeMiterlimit="10"
        />
        <path
          d="M93.8904 13.6676C93.8904 6.70028 99.5318 1.0589 106.499 1.0589C113.466 1.0589 119.108 6.71234 119.108 13.6676C119.108 20.6229 113.454 26.2764 106.499 26.2764C99.5438 26.2764 93.8904 20.6229 93.8904 13.6676Z"
          fill="white"
        />
        <path
          d="M93.3479 13.7055C93.3479 6.42471 99.2545 0.518127 106.535 0.518127C108.223 0.518127 109.838 0.831538 111.321 1.41014"
          stroke="currentColor"
          strokeWidth="1.04872"
          strokeMiterlimit="10"
        />
        <path
          d="M119.301 16.7207C118.397 20.5298 115.817 23.7724 112.273 25.4962"
          stroke="currentColor"
          strokeWidth="1.04872"
          strokeMiterlimit="10"
        />
        <path
          d="M106.511 23.7222C112.056 23.7222 116.564 19.226 116.564 13.681C116.564 8.13606 112.068 3.63983 106.511 3.63983C100.954 3.63983 96.47 8.13606 96.47 13.681C96.47 19.226 100.966 23.7222 106.511 23.7222Z"
          stroke="currentColor"
          strokeWidth="1.04872"
          strokeMiterlimit="10"
        />
        <path
          d="M110.646 11.0055L106.512 9.125L102.377 11.0055V16.3334L106.512 18.2139L110.646 16.3334V11.0055Z"
          fill="black"
        />
        <path
          d="M5.40088 71.9135C5.40088 64.9461 11.0423 59.3047 18.0096 59.3047C24.977 59.3047 30.6184 64.9582 30.6184 71.9135C30.6184 78.8688 24.9649 84.5222 18.0096 84.5222C11.0543 84.5222 5.40088 78.8688 5.40088 71.9135Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="0.578604"
          strokeMiterlimit="10"
        />
        <path
          d="M21.7344 59.2567C27.207 60.8599 31.197 65.9227 31.197 71.9137C31.197 72.8298 31.1005 73.7098 30.9318 74.5777"
          stroke="white"
          strokeWidth="1.04872"
          strokeMiterlimit="10"
        />
        <path
          d="M17.1659 84.9949C12.079 84.9226 7.73947 81.8487 5.81079 77.4851"
          stroke="white"
          strokeWidth="1.04872"
          strokeMiterlimit="10"
        />
        <path
          d="M18.0094 81.9569C23.5544 81.9569 28.0627 77.4606 28.0627 71.9157C28.0627 66.3707 23.5665 61.8745 18.0094 61.8745C12.4524 61.8745 7.96826 66.3707 7.96826 71.9157C7.96826 77.4606 12.4645 81.9569 18.0094 81.9569Z"
          stroke="white"
          strokeWidth="1.04872"
          strokeMiterlimit="10"
        />
        <path
          d="M22.1444 67.7805C19.8541 67.7805 18.0098 69.6369 18.0098 71.9151C18.0098 74.1934 19.8661 76.0497 22.1444 76.0497V67.7805Z"
          fill="black"
        />
        <path
          d="M13.8755 76.0497C16.1658 76.0497 18.0101 74.1934 18.0101 71.9151C18.0101 69.6369 16.1537 67.7805 13.8755 67.7805V76.0497Z"
          fill="black"
        />
        <path
          d="M4.15934 32.0406L0.723877 35.4761L4.15934 38.6464"
          stroke="white"
          strokeWidth="1.0005"
          strokeMiterlimit="10"
        />
        <path
          d="M12.7299 35.3416H0.723877"
          stroke="white"
          strokeWidth="1.0005"
          strokeMiterlimit="10"
        />
        <path
          d="M15.3337 27.3391L18.7571 23.9157L15.3337 20.7454"
          stroke="white"
          strokeWidth="1.0005"
          strokeMiterlimit="10"
        />
        <path
          d="M6.75122 24.0449H18.7573"
          stroke="white"
          strokeWidth="1.0005"
          strokeMiterlimit="10"
        />
        <path
          d="M47.8074 96.0018C47.8074 96.0018 52.617 87.8169 55.6547 87.6482C57.053 87.5759 58.3307 88.1183 59.4638 88.9018C60.5969 89.6854 61.9832 90.6256 63.4417 90.4568C64.7436 90.3122 65.9008 89.2876 66.7928 88.4076C70.0836 85.1168 77.8466 71.1098 77.8466 71.1098C77.8466 71.1098 81.2217 65.6251 85.272 68.1565C85.272 68.1565 86.7064 69.4222 87.4658 71.1098C88.2253 72.7974 89.9972 75.16 93.3724 74.9912C96.7476 74.8225 99.0259 68.8315 99.0259 68.8315C99.0259 68.8315 101.473 61.153 105.692 60.2248C109.911 59.2966 111.514 65.4563 111.514 65.4563L122.905 95.9053L47.8315 95.9897L47.8074 96.0018Z"
          fill="white"
        />
        <path
          d="M47.7712 71.2292C42.0816 65.853 39.0801 59.85 39.0801 53.859V37.9233"
          stroke="white"
          strokeWidth="1.0005"
          strokeMiterlimit="10"
        />
        <path
          d="M94.9155 39.7055L94.9999 25.2042L85.9592 21.2022"
          stroke="white"
          strokeWidth="1.0005"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <linearGradient
          id="borrower-protection-gradient"
          x1="32.4982"
          y1="47.9997"
          x2="101.28"
          y2="47.9997"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="#10192F" />
        </linearGradient>
        <clipPath id="borrower-protection-clip">
          <rect width="140.528" height="96" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
